var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon07Edit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 10.8c-.7-1.1-2.2-1.4-3.2-.6l-1.6 1.1V5.5c0-1.1-.9-2-2-2H6.6h-.1c-1.1.1-1.9.9-1.9 2v22.7c0 1.1.9 2 2 2h16.9c1.1 0 2-.9 2-2V16.9l4.2-2.8c.5-.3.9-.9 1-1.5.1-.7 0-1.3-.4-1.8zM24 28.2c0 .3-.2.5-.5.5H6.7c-.3 0-.5-.2-.5-.5V5.5c0-.3.2-.5.5-.5h16.8c.3 0 .5.2.5.5v6.7l-12.4 8.3c-.8.6-1.2 1.6-.9 2.5l-1.1.8c-.3.2-.4.7-.2 1 .1.2.4.3.6.3.1 0 .3 0 .4-.1l1.1-.8c.4.3.9.5 1.4.5.4 0 .9-.1 1.3-.4l9.8-6.6v10.5zm4.9-15.4L13.4 23.2c-.4.3-.9.2-1.2-.2-.1-.2-.2-.4-.1-.6 0-.2.2-.4.3-.5l15.5-10.4c.1-.1.3-.1.5-.1.3 0 .5.1.7.4.1.2.2.4.1.6 0 .1-.1.3-.3.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon07Edit);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_07_Edit.61cd7061.svg";
export { ForwardRef as ReactComponent };